import Fields from '@components/fields'
import SettingCard from '@pages/admin/settings/platforms/components/settingCard'
import { Form, Formik } from 'formik'
import { FC, useEffect, useState } from 'react'
import Column from '@components/column'
import Button from '@components/button'
import { useSelector } from 'react-redux'
import { GeneralSetting } from '@apis/index'
import { SettingSchema } from '@validations/index'
interface SeoForm {
  selector: string
  id: string
  title: string
}
const SeoForm: FC<SeoForm> = ({ selector, id, title }) => {
  const { data: seo } = useSelector((state: any) => state[selector])
  const initial = {
    value: {
      metaTitle: '',
      metaKeywords: '',
      metaDescription: '',
    },
    key: id,
    title: title,
  }
  const [initialValues, setInitialValues] = useState(initial)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const submitHandler = async (values) => {
    setIsLoading(true)
    if (seo?.id) {
      await GeneralSetting.update({
        id: seo.id,
        data: {
          ...values,
          value: JSON.stringify(values?.value),
        },
        state: selector,
      }).catch(() => {})
    } else {
      await GeneralSetting.create({
        data: {
          ...values,
          value: JSON.stringify(values?.value),
        },
        state: selector,
      }).catch(() => {})
    }
  }

  const fetchData = async () => {
    await GeneralSetting.getByKey({
      id: id,
      state: selector,
    }).catch(() => {})
  }

  useEffect(() => {
    if (seo?.id) {
      setInitialValues({
        ...initialValues,
        value: JSON.parse(seo?.value),
      })
    } else {
      setInitialValues(initial)
    }
  }, [seo?.id])

  useEffect(() => {
    if (!seo?.id) fetchData()
  }, [id])

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={submitHandler}
      enableReinitialize
      validationSchema={SettingSchema.seoValidationSchema}
    >
      {({ handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <SettingCard title={title}>
            <Column rowGap={30}>
              <Fields.Input
                type="text"
                name="value.metaTitle"
                placeholder="Meta Title"
                label="Meta Title"
              />
              <Fields.Input
                type="text"
                name="value.metaKeywords"
                placeholder="Meta Keywords"
                label="Meta Keywords"
              />
              <Fields.TextArea
                name="value.metaDescription"
                placeholder="Meta Description"
                label="Meta Description"
              />
            </Column>
          </SettingCard>
          <Column alignItems="flex-end" styleColumn="margin-top:30px;">
            <Button
              type="submit"
              title="Save"
              height={40}
              loading={isLoading}
            />
          </Column>
        </Form>
      )}
    </Formik>
  )
}

export default SeoForm
